$(document).ready(function () {
  // collection single varient
var video = $(".hover-video")[0]; // Get the DOM video element
    video.play();
  // Add mouseenter and mouseleave event handlers to the video container
  $(".hover-video")
    .on("mouseenter", function () {
      video.controls = true;
      // video.play(); // Pause the video when the mouse enters
    })
    .on("mouseleave", function () {
      video.controls = false;
      // video.pause(); // Play the video when the mouse leaves
    });

  // description tab on product page

  // Show the first tab and hide the rest
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $("#tabs-nav li").click(function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });










  
});

// For mobile view cart dot functionality

// $(document).on("click", ".dot", function () {
//   var varinatId = $(this).find(".dot_inner").data("id");
//   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
//   if (isMobile) {
//     $(".dot").addClass("quickView");
//     addToCart(varinatId, 1);
//   }
// });

var $jq = jQuery.noConflict();
$jq(document).ready(function () {
  $jq(".dot-slider-area").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0776/0304/5670/files/feier-shop-right.png?v=1706002162' alt='Feier Shop Right button'></button>",
    nextArrow:
      "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0776/0304/5670/files/feier-shop-left.png?v=1706002431' alt='Feier Shop left button'></button>",
    centerPadding: "190px",
    centerMode: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          centerMode: true,
          centerPadding: "128px",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          centerMode: true,
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

